import {
  newSlice,
  _fetchEntitiesService,
  _loadEvents,
  _updateEntityService,
  _updateOnlyEntityService,
} from "./common/sliceFunctions2";

var entitiesName = "coordinatorsList";

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code = "GET_COORDINATORSLIST";
  dataSlice.dataUrl.oid = dataSlice.orgId ? dataSlice.orgId : null;

  return _fetchEntitiesService(dataSlice, events);
}

export function updateEntityService(dataSlice) {
  dataSlice.dataUrl.code = "PUT_COORDINATORSLIST";
  return _updateEntityService(dataSlice, events);
}

export function updateOnlyEntityService(payload) {
  return _updateOnlyEntityService(payload, events);
}
